import { render, staticRenderFns } from "./placeholder.vue?vue&type=template&id=4e03d318&scoped=true&"
import script from "./placeholder.vue?vue&type=script&lang=js&"
export * from "./placeholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e03d318",
  null
  
)

export default component.exports